import React from 'react';
import { useSelector } from 'react-redux';
import EquipmentTemplate from '../../components/equiqtemplate/EquipmentTemplate';
import CustomImg1 from '../../assest/Custom-1.png';
import CustomImg2 from '../../assest/Custom-2.png';
import CustomImg3 from '../../assest/Custom-3.png';

const customTransportList = [
  {
    name: "Specialized Cargo",
    image: CustomImg1,
    specs: "Tailored transport for unique or oversized items.",
    description: "We design custom solutions to handle fragile, heavy, or irregularly shaped cargo with precision.",
  },
  {
    name: "Flexible Route Planning",
    image: CustomImg2,
    specs: "Optimized paths for non-standard deliveries.",
    description: "Dynamic planning that adapts to your schedule, load type, and site conditions.",
  },
  {
    name: "Integrated Support Services",
    image: CustomImg3,
    specs: "End-to-end assistance for logistics needs.",
    description: "From permits to escorts and scheduling, we handle all aspects of custom transport.",
  },
];

const translations = {
  gb: {
    heading: "Custom Transport Solutions",
    introText: "Innovative transport services for unique logistics challenges.",
    categoriesTitle: "Custom Options",
    featuredTitle: "Tailored Solutions",
    featuredDescription: "Expert support for transporting oversized, sensitive, or unusual equipment and materials.",
  },
  sa: {
    heading: "حلول النقل المخصصة",
    introText: "خدمات نقل مبتكرة لتحديات لوجستية فريدة.",
    categoriesTitle: "الخيارات المخصصة",
    featuredTitle: "حلول مخصصة",
    featuredDescription: "دعم احترافي لنقل المعدات والمواد الكبيرة أو الحساسة أو غير التقليدية.",
  },
};

const CustomTransportSolutions = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;

  return (
    <EquipmentTemplate
      content={t}
      equipmentList={customTransportList}
      language={language}
    />
  );
};

export default CustomTransportSolutions;
